export default __webpack_public_path__ + "static/media/blue_mob.5e8150fe.svg";